import { ASSET_PREFIX } from "utils/constants";
import styles from "./LotteryInfo.module.css";

interface ILotteryInfoProps {
    numberRanges: number[];
}

const LotteryInfo = ({numberRanges}: ILotteryInfoProps) => {
    const singleNumberEntry = numberRanges.length === 1;
    const numbersShouldBeDistinct = !singleNumberEntry;
    const numberOrNumbers = singleNumberEntry ? "number" : "numbers";
    const allNumberRangesAreEqual = numberRanges.every(
        (numberRange) => numberRange === numberRanges[0]
    );

    return (
        <div className={`${styles.lotteryInfoContainer}`}>
            <p className={`${styles.lotteryInfoText}`}>
                Enter {singleNumberEntry ? "a" : numberRanges.length}{" "}
                {numbersShouldBeDistinct ? "different" : ""} {numberOrNumbers}{" "}
                {allNumberRangesAreEqual
                    ? `between 1 – ${numberRanges[0].toLocaleString()}`
                    : ""}{" "}
                or tap
            </p>
            <img
                src={`${ASSET_PREFIX}/images/token-town/cherries-icon-green.svg`}
                alt="cherry icon"
                style={{ width: "20px", margin: "0 0.5em" }}
            />
            <p className={`${styles.lotteryInfoText}`}>
                for{singleNumberEntry ? " a" : ""} randomly selected {numberOrNumbers}
            </p>
        </div>
    )
}

export default LotteryInfo;